const { createBundleTiles } = require('../../shop/tiles/product-tile-factory');

class DynamicContentProductGroupTileListController {
    constructor(settings, productGroupService) {
        this.settings = settings;
        this.productGroupService = productGroupService;
    }

    createTiles(products) {
        return {
            items: createBundleTiles(products.items),
            totalRecordCount: products.totalRecordCount,
        };
    }

    getTiles() {
        return this.productGroupService.selectProductGroup(this.productGroupId)
            .then(() => this.productGroupService.getProducts({ pageNumber: 1, pageSize: 9999999, sortType: 'Name' }))
            .then(products => this.createTiles(products));
    }
}

DynamicContentProductGroupTileListController.$inject = ['Settings', 'ProductGroupService'];

const dynamicContentProductGroupTileListComponentDefinition = {
    bindings: {
        productGroupId: '<?',
    },
    controller: DynamicContentProductGroupTileListController,
    template: `
        <wow-tile-list
            should-get-inspiration-cards="false"
            get-tiles="$ctrl.getTiles()">
        </wow-tile-list>
    `,
};

module.exports = {
    DynamicContentProductGroupTileListController,
    dynamicContentProductGroupTileListComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/common/dynamiccontent/dynamic-content-product-group-tile-list.component.js